module.exports = __webpack_public_path__ + "img/missionaries8_2019_7-7-2021.c3237e3d.jpg";